    import React from 'react'
    import './error.css';
    function Error() {
      return (
        <div>
          <div id="main">
    	<div class="fof">
        		<h1>Error 404</h1>
    	</div>
</div>
        </div>
      )
    }
    
    export default Error
    